import SortableTreeDragOverlay from "./SortableTreeDragOverlay";
import SortableTreeManager from "./SortableTreeManager";

const SortableTree = {
  DragOverlay: SortableTreeDragOverlay,
  Manager: SortableTreeManager,
};
export default SortableTree;
